import React, { useMemo } from "react";

import { Car } from "../../../../../../services";
import { CellContentRoot } from "../../../../../LightTable";

const CarParkIdCellContent: React.FC<CarParkIdCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => item.park?.name ?? "", [item.park?.name]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CarParkIdCellContent {
	interface Props {
		item: Car.Model;
	}
}

export default CarParkIdCellContent;
